import React from 'react';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';

import styles from 'assets/jss/material-dashboard-pro-react/components/customInputStyle';

const useStyles = makeStyles(styles);

export default function CustomTextField(props) {
	const classes = useStyles();

	/* eslint-disable */
	const {
		labelText,
		labelProps,
		white,
		inputRootCustomClasses,
		success,
		autoComplete,
		autoFocus = false,
		children,
		className,
		color = 'primary',
		defaultValue,
		disabled = false,
		error = false,
		FormHelperTextProps,
		fullWidth = false,
		helperText,
		hiddenLabel,
		id,
		InputLabelProps,
		inputProps,
		InputProps,
		inputRef,
		label,
		multiline = false,
		name,
		onBlur,
		onChange,
		onFocus,
		placeholder,
		required = false,
		rows,
		rowsMax,
		select = false,
		SelectProps,
		type,
		value,
		variant = 'standard',
		...other
	} = props;
	/* eslint-enable */

	const labelClasses = classNames({
		[' ' + classes.labelRootError]: error,
		[' ' + classes.labelRootSuccess]: success && !error
	});
	const underlineClasses = classNames({
		[classes.underlineError]: error,
		[classes.underlineSuccess]: success && !error,
		[classes.underline]: true,
		[classes.whiteUnderline]: white
	});
	const marginTop = classNames({
		[inputRootCustomClasses]: inputRootCustomClasses !== undefined
	});
	const inputClasses = classNames({
		[classes.input]: true,
		[classes.whiteInput]: white
	});
	var helpTextClasses = classNames({
		[classes.helperText]: true,
		[' ' + classes.labelRootError]: error,
		[classes.labelRootSuccess]: success && !error
	});
	let newInputProps = {
		...inputProps,
		maxLength:
			inputProps && inputProps.maxLength ? inputProps.maxLength : undefined,
		minLength:
			inputProps && inputProps.minLength ? inputProps.minLength : undefined
	};
	const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
	const inputLabelId = label && id ? `${id}-label` : undefined;
	return (
		<FormControl fullWidth={fullWidth} className={classes.formControl}>
			{label !== undefined ? (
				<InputLabel
					className={`${classes.labelRoot} ${labelClasses}`}
					id={inputLabelId}
					{...labelProps}
				>
					{label}
				</InputLabel>
			) : null}
			<Input
				classes={{
					input: inputClasses,
					root: marginTop,
					disabled: classes.disabled,
					underline: underlineClasses,
				}}
				id={id}
				inputProps={newInputProps}
				onChange={onChange}
				disabled={disabled}
				aria-describedby={helperTextId}
				autoComplete={autoComplete}
				autoFocus={autoFocus}
				defaultValue={defaultValue}
				fullWidth={fullWidth}
				multiline={multiline}
				name={name}
				rows={rows}
				rowsMax={rowsMax}
				type={type}
				value={value}
				inputRef={inputRef}
				onBlur={onBlur}
				onFocus={onFocus}
				placeholder={placeholder}
				{...InputProps}

			/>
			{helperText !== undefined ? (
				<FormHelperText id={id + '-text'} className={helpTextClasses}>
					{helperText}
				</FormHelperText>
			) : null}
		</FormControl>
	);
}

CustomTextField.propTypes = {
	labelText: PropTypes.node,
	labelProps: PropTypes.object,
	id: PropTypes.string,
	inputProps: PropTypes.object,
	formControlProps: PropTypes.object,
	inputRootCustomClasses: PropTypes.string,
	error: PropTypes.bool,
	success: PropTypes.bool,
	white: PropTypes.bool,
	helperText: PropTypes.node
};
